<mat-chip-listbox
  class="status-filter"
  aria-label="Filtrar itens por status"
  hideSingleSelectionIndicator
  [value]="selectedStatus()"
  (change)="onChange($event)">
  @for (option of options(); track option.value) {
    <mat-chip-option
      [value]="option.value"
      [attr.aria-label]="option.label + (option.count != null ? ', ' + option.count : '')">
      {{ option.label }}
      @if (option.count != null) {
        <span class="status-filter-count">{{ option.count }}</span>
      }
    </mat-chip-option>
  }
</mat-chip-listbox>
